import { render, staticRenderFns } from "./CatalogueForm.vue?vue&type=template&id=19efc0c2&scoped=true"
import script from "./CatalogueForm.vue?vue&type=script&lang=js"
export * from "./CatalogueForm.vue?vue&type=script&lang=js"
import style0 from "./CatalogueForm.vue?vue&type=style&index=0&id=19efc0c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19efc0c2",
  null
  
)

export default component.exports